
const ShareIcon = ({
    color = '#000',
    fondo = '#fff',
    vetor_css = { fontSize: '50px' },
    main_css = { width: '40px', padding: '0px' }
}) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" style={main_css}  viewBox="0 0 57.000000 51.000000" preserveAspectRatio="xMidYMid meet">
            <g transform="translate(0.000000,51.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
                <path d="M325 488 c-2 -7 -6 -33 -7 -58 l-3 -45 -84 -7 c-136 -11 -210 -63 -226 -157 -3 -21 -2 -57 4 -78 15 -54 66 -123 91 -123 23 0 23 -4 9 58 -21 98 25 148 146 159 l65 6 0 -57 c0 -41 4 -58 15 -62 19 -8 215 161 215 185 0 10 -12 28 -27 41 -16 13 -61 52 -101 87 -74 65 -89 72 -97 51z" />
            </g>
        </svg>
    )
}

export default ShareIcon;